import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import ReviewForm from "./componance/reviews/ReviewForm";
import { Trash } from "lucide-react";
import NavBar from "./componance/NavBar";
import Footer from "./componance/Footer";
import { useAuth } from "./Authen/AuthContext";
import ReviewList from "./componance/reviews/ReviewList";
const API_BASE = "https://summerhousagentlive.onrender.com/api";

const ReviewPage = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const [properties, setProperties] = useState([]);
  const [selectedPropertyId, setSelectedPropertyId] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [allReviews, setAllReviews] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchProperties = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/properties`);
      const data = await res.json();
      const propsArray = Array.isArray(data) ? data : [];
      setProperties(propsArray);
      setSelectedPropertyId(null);
    } catch (err) {
      console.error(t("fetchPropertiesError"), err);
    }
  }, [t]);

  const fetchAllReviews = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/reviews`);
      const data = await res.json();
      const revs = data.reviews ? data.reviews : Array.isArray(data) ? data : [];
      setAllReviews(revs);
    } catch (err) {
      console.error(t("fetchAllReviewsError"), err);
      setAllReviews([]);
    }
  }, [t]);

  const fetchReviewsByProperty = useCallback(
    (propertyId) => {
      if (propertyId === null) {
        setReviews(allReviews.filter((r) => !r.property_id));
        return;
      }
      setReviews(allReviews.filter((r) => r.property_id === propertyId));
    },
    [allReviews]
  );

  const handleDelete = async (id) => {
    if (!user || user.role?.toLowerCase() !== "admin") {
      alert(t("noPermissionDelete"));
      return;
    }
    if (!window.confirm(t("confirmDelete"))) return;

    try {
      const res = await fetch(`${API_BASE}/reviews/${id}`, { method: "DELETE" });
      if (res.ok) {
        setAllReviews((prev) => prev.filter((r) => r.id !== id));
        setReviews((prev) => prev.filter((r) => r.id !== id));
      } else alert(t("deleteFailed"));
    } catch (err) {
      console.error(err);
      alert(t("deleteError"));
    }
  };

  useEffect(() => {
    fetchProperties();
    fetchAllReviews();
  }, [fetchProperties, fetchAllReviews]);

  useEffect(() => {
    fetchReviewsByProperty(selectedPropertyId);
  }, [selectedPropertyId, fetchReviewsByProperty]);

  const renderStars = (rating) => "⭐".repeat(rating);

  const renderReviewList = (reviewArray) =>
    reviewArray.length === 0 ? (
      <p style={styles.noReviews}>{t("noReviews")}</p>
    ) : (
      <div style={styles.gridContainer}>
        {reviewArray.map((r) => {
          const property = properties.find((p) => p.property_id === r.property_id);
          const propertyName = property?.name || t("noProperty") || "No property";

          return (
            <div
              key={r.id}
              style={styles.card}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <div style={styles.propertyName}>{propertyName}</div>

              <div style={styles.cardHeader}>
                <strong style={styles.reviewerName}>{r.reviewer_name || "-"}</strong>
                {user?.role?.toLowerCase() === "admin" && (
                  <button onClick={() => handleDelete(r.id)} style={styles.deleteButton}>
                    <Trash size={18} />
                  </button>
                )}
              </div>

              <div style={styles.ratingText}>
                {t("rating")}: <span style={styles.stars}>{renderStars(r.rating || 0)}</span>
              </div>

              <p style={styles.reviewText}>{r.review_text || "-"}</p>

              {r.images && r.images.length > 0 && (
                <div style={styles.imageContainer}>
                  {r.images.map((img, idx) => (
                    <img key={idx} src={img} alt="review" style={styles.image} />
                  ))}
                </div>
              )}

              <small style={styles.dateText}>
                {r.created_at ? new Date(r.created_at).toLocaleDateString() : "-"}
              </small>
            </div>
          );
        })}
      </div>
    );

  return (
    <div style={styles.page}>
      <NavBar />

      <div style={styles.container}>
        <div style={styles.propertySelectContainer}>
          <h2 style={styles.heading}>{t("Reviews")}</h2>
          <div style={styles.center}>
           
          </div>
        </div>

        {/* Section Desktop: ฟอร์ม+รีวิวฝั่งซ้าย, รีวิวรวมฝั่งขวา */}
        <div style={styles.reviewSection}>
          <div style={styles.leftPanel}>
            <h3 style={styles.heading}>{t("reviewsByProperty")}</h3>
            <div style={styles.center}>
              {user ? (
                <ReviewForm propertyId={selectedPropertyId} onNewReview={fetchAllReviews} />
              ) : (
                <button style={styles.reviewButton} onClick={() => alert(t("loginRequired"))}>
                  {t("reviewProperty")}
                </button>
                
              )}
              {user && (
                <select
                    value={selectedPropertyId ?? ""}
                    onChange={(e) => {
                    const val = e.target.value;
                    setSelectedPropertyId(val === "" ? null : Number(val));
                    }}
                    style={styles.select}
                >
                    <option value="">{t("noProperty") || "No property"}</option>
                    {properties.map((p) => (
                    <option key={p.property_id} value={p.property_id}>
                        {p.name || `${t("property")} ${p.property_id}`}
                    </option>
                    ))}
                </select>
                )}



            </div>
         
          </div>

          <div style={styles.rightPanel}>
            <h3 style={styles.heading}>{t("allReviews")}</h3>
            <ReviewList
                reviews={allReviews}
                properties={properties}
                user={user}
                handleDelete={handleDelete}
                t={t}
            />
            </div>



        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ReviewPage;

// 🎨 STYLE OBJECTS
const styles = {
  page: {
    fontFamily: "'Kanit', sans-serif",
    backgroundColor: "#f5f7fa",
    minHeight: "100vh",
  },
  container: {
    maxWidth: "1200px",
    margin: "2rem auto",
    padding: "0 1rem",
    
  },
  heading: {
    marginBottom: "1rem",
    color: "#1a2e35",
  },
  propertySelectContainer: {
    marginBottom: "2rem",
  },
  hr: {
    margin: "2rem 0",
    borderColor: "#ddd",
  },
  center: {
    
    marginBottom: "1rem",
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "1.5rem",
    justifyContent: "center",
    alignItems: "stretch",
    padding: "1rem 0",
  },
  card: {
    width: "100%",
    maxWidth: "300px",
    minHeight: "300px",
    border: "1px solid #eee",
    padding: "20px",
    borderRadius: "12px",
    backgroundColor: "#fff",
    boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
    transition: "transform 0.2s ease",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  propertyName: {
    marginBottom: "6px",
    fontWeight: "600",
    color: "#1a2e35",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  reviewerName: {
    fontSize: "1rem",
    color: "#0a71e7",
  },
  deleteButton: {
    background: "none",
    border: "none",
    color: "red",
    cursor: "pointer",
  },
  ratingText: {
    marginBottom: "6px",
    color: "#333",
  },
  stars: {
    fontWeight: "600",
    color: "#ff9500",
  },
  reviewText: {
    color: "#555",
    marginBottom: "8px",
  },
  imageContainer: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
    marginBottom: "8px",
  },
  image: {
    width: "285px",
    height: "250px",
    objectFit: "cover",
    borderRadius: "8px",
    border: "1px solid #ddd",
  },
  dateText: {
    color: "#999",
  },
  select: {
    padding: "0.5rem 1rem",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "1rem",
  },
  reviewButton: {
    padding: "12px 24px",
    borderRadius: "12px",
    border: "none",
    background: "linear-gradient(90deg, #0a71e7, #3db2ff)",
    color: "#fff",
    fontWeight: "600",
    fontSize: "1rem",
    cursor: "pointer",
    boxShadow: "0 6px 15px rgba(10, 113, 231, 0.3)",
    transition: "all 0.3s ease",
  },
  noReviews: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    color: "#777",
    minHeight: "40vh",
    width: "100%",
  },

  // ⭐ Section ฟอร์ม+รีวิว (Desktop / Mobile)
  reviewSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "2rem",
    flexWrap: "wrap", // Mobile จะเรียงลง
  },
  leftPanel: {
    flex: "1",
    minWidth: "300px",
  },
  rightPanel: {
    flex: "2",
    minWidth: "320px",
  },

  // Responsive
  "@media (max-width: 768px)": {
    reviewSection: {
      flexDirection: "column",
      alignItems: "center",
    },
    leftPanel: {
      width: "100%",
      marginBottom: "1.5rem",
    },
    rightPanel: {
      width: "100%",
    },
  },
};
